module.exports = __webpack_public_path__ + "img/index_middle-02@2x.b5868877.png";